import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

export interface NotifyMePayload {
  productName: string;
  customerName: string;
  customerLastName: string;
  customerEmail: string;
  customerCellNumber: string;
}

@Injectable({
  providedIn: 'root'
})
export class NotifyMeService {
  private notifyMeUrl = 'https://ecu.mycariq.com/Cariq/notification/notifyMe';

  constructor(private http: HttpClient) {}

  submitNotifyMe(payload: NotifyMePayload): Observable<any> {
    const headers = new HttpHeaders({
      Authorization: 'Basic dXNlcjoxZ25pVElPTktleTc4Njg=',
      'Content-Type': 'application/json'
    });

    return this.http.post<any>(this.notifyMeUrl, payload, { headers });
  }
}
